import script from "./ButtonToggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonToggle.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonToggle.vue?vue&type=style&index=0&id=6ac6b8b9&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac6b8b9"]])

export default __exports__